// 刚刚封装的axios
import request from '../index.js';

//绑定真实物理模型
export const apiModel = () => {
  return request({
      url: '/iotApiModel/getIotApiModel',
      method: 'GET'
  })
}
// 绑定真实物理模型
export const physicalModel = (query) => {
  return request({
      url: '/iotApiModel/getIotApiThingModel',
      method: 'GET',
      params: query
  })
}
// 根据UUID获取实时数据
export const realTimeData = (query) => {
  return request({
      url: '/iotApiRealTimeData/getRealTimeData',
      method: 'POST',
      data: query
  })
}
// 获取7日历史数据
export const sevenDay = (query) => {
  return request({
      url: '/apiDataHistory/getApiDataListByDate',
      method: 'GET',
      data: query
  })
}
// 站内-获取历史数据
export const getApiDataList = (query) => {
  return request({
      url: '/apiDataHistory/getApiDataList',
      method: 'POST',
      data: query
  })
}
// 站外-获取历史数据
export const getIotDataList = (query) => {
  return request({
      url: '/apiDataHistory/getIotDataList',
      method: 'POST',
      data: query
  })
}
// 大屏 获取预警数量
export const getAlarmQuantity = (query) => {
  return request({
      url: '/iotMonitor/getAlarmQuantity',
      method: 'GET',
      params: query
  })
}
// 大屏 获取设备状态统计
export const getDeviceStatus = (query) => {
  return request({
      url: '/iotMonitor/getDeviceStatus',
      method: 'GET',
      data: query
  })
}
// 大屏 获取预警消息列表
export const getIotAlarmList = (query) => {
  return request({
      url: '/iotMonitor/getIotAlarmList',
      method: 'POST',
      data: query
  })
}
// 大屏 获取监控数量
export const getMonitorQuantity = (query) => {
  return request({
      url: '/iotMonitor/getMonitorQuantity',
      method: 'GET',
      data: query
  })
}

